import React, { useState, useEffect } from 'react';
import { Card, Col, Form, Row, Table, Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { useDropzone } from 'react-dropzone';
import { ErrorMessage, useFormikContext } from 'formik';
import { RootState } from '../../store/rootReducer';
import { ApplicationIndustry } from '../../api/openapi';
import { CreateApplicationFormValues } from '../../views/ApplicationCreate';

const ApplicationFilesUpload = (): React.ReactElement => {
  const { t } = useTranslation(['createApplication', 'common']);
  const { industries } = useSelector((state: RootState) => state.createApplication);
  const { values, setFieldValue } = useFormikContext<CreateApplicationFormValues>();
  const [selectedIndustry, setSelectedIndustry] = useState<ApplicationIndustry | undefined>();

  useEffect(() => {
    let value;
    if (industries != null && values.industry != null) {
      value = industries.find((s) => `${s.id}` === values.industry?.id);
    }

    setSelectedIndustry(value);
    setFieldValue('industryPensionFundRequired', !!value?.requiresPensionfundFile);
  }, [industries, values.industry, setFieldValue]);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (acceptedFiles) => {
      const newFiles = [...values.files, ...acceptedFiles];
      const newExtra = [
        ...values.filesExtra,
        ...acceptedFiles.map(() => ({
          isPensionFundFile: false,
        })),
      ];
      setFieldValue('filesExtra', newExtra);
      setFieldValue('files', newFiles);
    },
  });

  const removeFile = (idx: number) => {
    const filesTemp = [...values.files];
    const extraTemp = [...values.filesExtra];
    filesTemp.splice(idx, 1);
    extraTemp.splice(idx, 1);
    setFieldValue('filesExtra', extraTemp);
    setFieldValue('files', filesTemp);
  };

  const renderFiles = values.files.map((file, idx) => (
    <tr key={file.path}>
      <td>{file.path}</td>

      <td>
        {selectedIndustry?.requiresPensionfundFile && (
          <Form.Check
            custom
            id={`isPensionfundFile-yes-${idx}`}
            name={`isPensionfundFile-${idx}`}
            inline
            label={t('isPensionfundFile')}
            type="checkbox"
            checked={values.filesExtra[idx].isPensionFundFile}
            onChange={(e) => setFieldValue(`filesExtra[${idx}].isPensionFundFile`, e.target.checked)}
          />
        )}
      </td>
      <td>
        <Button className="p-0 iconColorRed" variant="link" onClick={() => removeFile(idx)}>
          <FontAwesomeIcon icon={faTrash} fixedWidth />
        </Button>
      </td>
    </tr>
  ));

  return (
    <Card className="mb-2">
      <Card.Body>
        <Row>
          <Col>
            <h4>{t('filesAndImages')}</h4>
          </Col>
        </Row>
        <Row>
          <Col md="4">
            <p className="small text-muted">{t('filesAndImagesHelp')}</p>
          </Col>
          <Col md="8">
            <div {...getRootProps({ className: 'dropzone' })}>
              <input {...getInputProps()} />
              <p className="mt-3">{t('dragOrDropFile')}</p>
              {/* <em>{t('onlyTheseFiles')}</em> */}
            </div>
            <aside>
              <Table>
                <tbody>{renderFiles}</tbody>
              </Table>
            </aside>
            <ErrorMessage name="filesExtra" component="div" className="invalid-feedback d-block text-left" />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};
export default ApplicationFilesUpload;
